import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _ from 'lodash';
import {connect} from "react-redux";

const SurveyForm = class extends Component{
    source = axios.CancelToken.source();

    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
    pickfields = [];
    roofFields = ['Structure_Levels__c','Is_There_Existing_Solar__c'];
    electricalFields = ['Siding_Type__c', 'Multiple_Service_Meters__c', 'Utility_Feed__c', 'Meter_Number__c', 'MSP_Mounting__c', 'Grounding__c', 'Gas_Riser_Distance_in__c', 'MSP_Condition__c',
        'MSP_Brand__c', 'MSP_Feed__c', 'Main_Breaker_Rating__c', 'MSP_Busbar_Rating__c', 'Is_There_Existing_Solar__c'];
    generalFields = ['Site_Survey_Outcome__c', 'What_Was_Partially_Completed__c', 'What_Was_Fully_Completed__c', 'Any_unpermitted_structures__c', 'Was_the_customer_home__c', 'Drone_Survey__c', 'Internet_Access__c'];

    componentDidMount(){
        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/Ceiling_Type__c;Roof_mossy_or_slippery__c;Attic_Structure__c;Roof_Type__c;Roof_Condition__c;Roof_mossy_or_slippery__c;' +
            'Structure_2_Ceiling_Type__c;Structure_2_Attic_Structure__c;Structure_2_Roof_Mossy_or_Slippery__c;Structure_2_Fragile_or_Lightweight_Tile__c;' +
            'Structure_2_Roof_Condition__c;Structure_2_Roof_Type__c;Waste_Management_Method__c;Siding_Type__c;Utility_Feed__c;MSP_Mounting__c;Grounding__c;' +
            'MSP_Condition__c;MSP_Brand__c;MSP_Feed__c;Main_Breaker_Rating__c;MSP_Busbar_Rating__c;Existing_PV_Breaker_Size__c;Existing_ACD__c;Select_materials_in_the_trench_path__c;' +
            'What_Was_Partially_Completed__c;What_Was_Fully_Completed__c;Site_Survey_Outcome__c;What_Was_The_Reason_For_Cancelling__c;Cancellation_Type__c;Internet_Access__c;Special_Panel__c;' +
            'TRX_Shared__c;Existing_generator_or_transfer_switch__c;Ground_Rod_811_Marking__c;System_A_Existing_Battery_Mfr__c;System_B_Existing_Battery_Mfr__c;',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        Site_Survey_Outcome__c: this.props.fieldJob.Site_Survey_Outcome__c,
        What_Was_Partially_Completed__c: this.props.fieldJob.What_Was_Partially_Completed__c,
        What_Was_Fully_Completed__c: this.props.fieldJob.What_Was_Fully_Completed__c,
        Any_unpermitted_structures__c: this.props.fieldJob.Any_unpermitted_structures__c,
        Was_the_customer_home__c: this.props.fieldJob.Was_the_customer_home__c,
        Drone_Survey__c: this.props.fieldJob.Drone_Survey__c,
        Structure_Levels__c: this.props.fieldJob.Structure_Levels__c,
        Attic_Structure__c: this.props.fieldJob.Attic_Structure__c,
        Ceiling_Type__c: this.props.fieldJob.Ceiling_Type__c,
        Rafters2__c: this.props.fieldJob.Rafters2__c,
        Is_There_Existing_Solar__c: this.props.fieldJob.Is_There_Existing_Solar__c,
        Rafter_Spacing2__c: this.props.fieldJob.Rafter_Spacing2__c,
        Roof_Tilt__c: this.props.fieldJob.Roof_Tilt__c,
        Roof_Type__c: this.props.fieldJob.Roof_Type__c,
        Fragile_or_lightweight_tile__c: this.props.fieldJob.Fragile_or_lightweight_tile__c,
        Number_of_Broken_Tiles__c: this.props.fieldJob.Number_of_Broken_Tiles__c,
        Roof_Condition__c: this.props.fieldJob.Roof_Condition__c,
        Roof_mossy_or_slippery__c: this.props.fieldJob.Roof_mossy_or_slippery__c,
        Structure_2_Ceiling_Type__c: this.props.fieldJob.Structure_2_Ceiling_Type__c,
        Structure_2_Attic_Structure__c: this.props.fieldJob.Structure_2_Attic_Structure__c,
        Structure_2_Rafters__c: this.props.fieldJob.Structure_2_Rafters__c,
        Structure_2_Rafter_Spacing__c: this.props.fieldJob.Structure_2_Rafter_Spacing__c,
        Structure_2_Fragile_or_Lightweight_Tile__c: this.props.fieldJob.Structure_2_Fragile_or_Lightweight_Tile__c,
        Structure_2_Number_of_Broken_Tiles__c: this.props.fieldJob.Structure_2_Number_of_Broken_Tiles__c,
        Structure_2_Roof_Condition__c: this.props.fieldJob.Structure_2_Roof_Condition__c,
        Structure_2_Roof_Mossy_or_Slippery__c: this.props.fieldJob.Structure_2_Roof_Mossy_or_Slippery__c,
        Structure_2_Roof_Tilt__c: this.props.fieldJob.Structure_2_Roof_Tilt__c,
        Structure_2_Roof_Type__c: this.props.fieldJob.Structure_2_Roof_Type__c,
        Third_structure_being_surveyed__c: this.props.fieldJob.Third_structure_being_surveyed__c,
        Waste_Management_Method__c: this.props.fieldJob.Waste_Management_Method__c,
        Siding_Type__c: this.props.fieldJob.Siding_Type__c,
        Utility_Feed__c: this.props.fieldJob.Utility_Feed__c,
        Meter_Number__c: this.props.fieldJob.Meter_Number__c,
        Multiple_Service_Meters__c: this.props.fieldJob.Multiple_Service_Meters__c,
        MSP_Mounting__c: this.props.fieldJob.MSP_Mounting__c,
        Grounding__c: this.props.fieldJob.Grounding__c,
        Gas_Riser_Distance_in__c: this.props.fieldJob.Gas_Riser_Distance_in__c,
        MSP_Condition__c: this.props.fieldJob.MSP_Condition__c,
        MSP_Brand__c: this.props.fieldJob.MSP_Brand__c,
        MSP_Feed__c: this.props.fieldJob.MSP_Feed__c,
        Main_Breaker_Rating__c: this.props.fieldJob.Main_Breaker_Rating__c,
        MSP_Busbar_Rating__c: this.props.fieldJob.MSP_Busbar_Rating__c,
        Any_panels_missing_dead_front__c: this.props.fieldJob.Any_panels_missing_dead_front__c,
        Existing_PV_Breaker_Size__c: this.props.fieldJob.Existing_PV_Breaker_Size__c,
        Multiple_Existing_Inverters__c: this.props.fieldJob.Multiple_Existing_Inverters__c,
        Existing_Inverter_Model_Number__c: this.props.fieldJob.Existing_Inverter_Model_Number__c,
        Existing_ACD__c: this.props.fieldJob.Existing_ACD__c,
        Multiple_Existing_Solar_Systems__c: this.props.fieldJob.Multiple_Existing_Solar_Systems__c, 
        Trench_Needed__c: this.props.fieldJob.Trench_Needed__c, 
        Trench_Distance__c: this.props.fieldJob.Trench_Distance__c, 
        Select_materials_in_the_trench_path__c: this.props.fieldJob.Select_materials_in_the_trench_path__c,
        Largest_Breaker__c: this.props.fieldJob.Largest_Breaker__c, 
        AC_Unit__c: this.props.fieldJob.AC_Unit__c, 
        Largest_AC_Unit_Breaker_Size__c: this.props.fieldJob.Largest_AC_Unit_Breaker_Size__c, 
        LRA1__c: this.props.fieldJob.LRA1__c, 
        LRA2__c: this.props.fieldJob.LRA2__c, 
        LRA3__c: this.props.fieldJob.LRA3__c,
        Existing_Array_Tilt__c: this.props.fieldJob.Existing_Array_Tilt__c,
        Existing_Array_Azimuth__c: this.props.fieldJob.Existing_Array_Azimuth__c,
        Existing_module_number__c: this.props.fieldJob.Existing_module_number__c,
        Number_of_existing_modules__c: this.props.fieldJob.Number_of_existing_modules__c,
        What_Was_The_Reason_For_Cancelling__c: this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c,
        Needs_follow_up__c: this.props.fieldJob.Needs_follow_up__c,
        Job_Notes__c: this.props.fieldJob.Job_Notes__c,
        Dropbox_Link__c: this.props.fieldJob.Dropbox_Link__c,
        Is_there_an_existing_EV_charger__c: this.props.fieldJob.Is_there_an_existing_EV_charger__c,
        What_is_the_Amperage_of_EV_Charger_Break__c: this.props.fieldJob.What_is_the_Amperage_of_EV_Charger_Break__c,
        Is_the_EV_charger_permitted__c: this.props.fieldJob.Is_the_EV_charger_permitted__c,
        Existing_generator_or_transfer_switch__c: this.props.fieldJob.Existing_generator_or_transfer_switch__c,
        What_is_the_Amp_of_Generator_Breaker__c: this.props.fieldJob.What_is_the_Amp_of_Generator_Breaker__c,
        Is_the_Generator_permitted__c: this.props.fieldJob.Is_the_Generator_permitted__c,
        Cancellation_Type__c: this.props.fieldJob.Cancellation_Type__c,
        What_do_we_need_from_this_RSS__c: this.props.fieldJob.What_do_we_need_from_this_RSS__c,
        Internet_Access__c: this.props.fieldJob.Internet_Access__c,
        Plywood__c: this.props.fieldJob.Plywood__c,
        Special_Panel__c: this.props.fieldJob.Special_Panel__c,
        TRX_Shared__c: this.props.fieldJob.TRX_Shared__c,
        Number_of_Sub_panels__c: this.props.fieldJob.Number_of_Sub_panels__c,
        X3_Phase__c: this.props.fieldJob.X3_Phase__c,
        //System_A_Battery__c: this.props.fieldJob.System_A_Battery__c,
        System_A_Existing_Battery_Mfr__c: this.props.fieldJob.System_A_Existing_Battery_Mfr__c,
        //System_B_Battery__c: this.props.fieldJob.System_B_Battery__c,
        System_B_Existing_Battery_Mfr__c: this.props.fieldJob.System_B_Existing_Battery_Mfr__c,
        Ground_Rod_811_Marking__c: this.props.fieldJob.Ground_Rod_811_Marking__c,

        Tile_Weight__c: this.props.fieldJob.Tile_Weight__c,
        tilePounds: '',
        tileOunces: ''
    };

    saveFields = () => {
        const payload = {...this.state};

        if(this.validationSaveCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;

            if(this.state.tilePounds !== '' || this.state.tileOunces !== ''){
                payload.Tile_Weight__c = this.state.tilePounds + 'lbs ' + this.state.tileOunces + 'oz';
            }
            
            delete payload.tilePounds;
            delete payload.tileOunces;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;

            if(this.state.tilePounds !== '' || this.state.tileOunces !== ''){
                payload.Tile_Weight__c = this.state.tilePounds + 'lbs ' + this.state.tileOunces + 'oz';
            }

            delete payload.tilePounds;
            delete payload.tileOunces;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    validationSaveCheck = (payload) => {
        let valid = true;
        let threeDigitNums = ['Existing_Array_Tilt__c','Existing_Array_Azimuth__c','Number_of_existing_modules__c', 'Largest_Breaker__c',
            'Largest_AC_Unit_Breaker_Size__c', 'Number_of_Broken_Tiles__c','Structure_2_Rafter_Spacing__c','Structure_2_Roof_Tilt__c'];
        let textValues = ['Rafters2__c', 'Existing_module_number__c', 'Structure_2_Rafters__c', 'Meter_Number__c', 'Existing_Inverter_Model_Number__c'];

        for(const key of threeDigitNums) {
            if(payload[key] !== null && (payload[key] < 0 || payload[key] > 999)) {
                this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for ' + key})
                valid = false;
                break;
            }
        }

        for(const key of textValues) {
            if(payload[key] !== null && payload[key].length > 255) {
                this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for ' + key})
                valid = false;
                break;
            }
        }

        if(payload['Job_Notes__c'] !== null && payload['Job_Notes__c'].length > 5000) {
            this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for Field Notes'})
            valid = false;
        }

        if(payload['Structure_Levels__c'] !== null && (payload['Structure_Levels__c'] < 1 || payload['Structure_Levels__c'] > 3)) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Structure Levels'})
            valid = false;
        }

        if(payload['Roof_Tilt__c'] !== null && (payload['Roof_Tilt__c'] < 0 || payload['Roof_Tilt__c'] > 99)) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Roof Tilt'})
            valid = false;
        }

        if(payload['Rafter_Spacing2__c'] !== null && (payload['Rafter_Spacing2__c'] < 0 || payload['Rafter_Spacing2__c'] > 9999)) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Rafter Spacing'})
            valid = false;
        }

        if(payload['Gas_Riser_Distance_in__c'] !== null && (payload['Gas_Riser_Distance_in__c'] < 0 || payload['Gas_Riser_Distance_in__c'] > 9999)) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Gas Riser Distance'})
            valid = false;
        }

        if(payload['tilePounds'] !== null && payload['tilePounds'] < 0) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Tile Weight Pounds'})
            valid = false;
        }

        if(payload['tileOunces'] !== null && (payload['tileOunces'] < 0 || payload['tileOunces'] > 15)) {
            this.setState({shouldShowAlert: true, alertMessage: 'Not A Valid Value for Tile Weight Ounces'})
            valid = false;
        }

        return valid;
    };

    validationCompleteCheck = (payload) => {
        let valid = true; 

        if(this.validationSaveCheck(payload)){
            if(this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('House') && this.state.Site_Survey_Outcome__c !== 'Cancelled') {
                for (const key in payload) {
                    if(this.roofFields.includes(key)){
                        if(payload[key] === null) {
                            let alertMessage;
                            key === 'Structure_Levels__c' ? alertMessage = 'Please Enter Number of Structure Levels' : alertMessage = 'Please Enter if There is Existing Solar'
                            this.setState({shouldShowAlert: true, alertMessage: alertMessage})
                            valid = false;
                            break;
                        }
                    }
                }

                if(this.state.tilePounds === '' && this.state.tileOunces === ''){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Enter Tile Weight'})
                    valid = false;
                }
            }

            if(this.props.session.Survey_Type__c !== null && this.state.Site_Survey_Outcome__c !== 'Cancelled') {
                for (const key in payload) {
                    if(this.generalFields.includes(key)){
                        if(key === 'Site_Survey_Outcome__c' && payload[key] === 'Partial Completion' && payload['What_Was_Partially_Completed__c'] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        } else if(key === 'Site_Survey_Outcome__c' && payload[key] === 'Full Completion' && payload['What_Was_Fully_Completed__c'] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        } else if(key !== 'What_Was_Partially_Completed__c' && key !== 'What_Was_Fully_Completed__c' && payload[key] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out General Section Before Ending Job'})
                            valid = false;
                            break;
                        }
                    }

                    if(this.electricalFields.includes(key) && this.state.Site_Survey_Outcome__c !== 'Cancelled'){
                        if(payload[key] === null) {
                            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) in Electrical Section Before Ending Job'})
                            valid = false;
                            break;
                        }
                    }
                }
            }

            if(this.state.Site_Survey_Outcome__c === 'Cancelled' && this.state.Cancellation_Type__c === 'Full Cancel') {
                if(payload['What_Was_The_Reason_For_Cancelling__c'] === null || payload['Needs_follow_up__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Reason for Cancellation and if Follow up is Needed'});
                    valid = false;
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.setState({[field]: this.assignMultiple(event.target.selectedOptions)})} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    assignMultiple = (value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        return groupedValues;
    }

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            <div className="d-flex justify-content-between mt-5 mb-4">
                {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>
            {
                this.state.isEditing ?
                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">General</h2>
                    <div>
                        <label htmlFor="Site_Survey_Outcome__c">Site Survey Outcome *</label>
                        {this.getInput('picklist', 'Site_Survey_Outcome__c', this.state.Site_Survey_Outcome__c, this.pickfields.Site_Survey_Outcome__c.picklistValues)}
                    </div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? 'd-none' : ''}>

                        <div className={this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === null ? '' : 'd-none'}>
                            <label htmlFor="What_Was_Partially_Completed__c">What was partially completed? *</label>
                            {this.getInput('picklist', 'What_Was_Partially_Completed__c', this.state.What_Was_Partially_Completed__c, this.pickfields.What_Was_Partially_Completed__c.picklistValues)}
                        </div>
                        <div className={this.state.Site_Survey_Outcome__c === 'Full Completion' ? '' : 'd-none'}>
                            <label htmlFor="What_Was_Fully_Completed__c">What was fully completed? *</label>
                            {this.getInput('picklist', 'What_Was_Fully_Completed__c', this.state.What_Was_Fully_Completed__c, this.pickfields.What_Was_Fully_Completed__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Any unpermitted structures? *</label>
                            {this.getInput('yesNo', 'Any_unpermitted_structures__c', this.state.Any_unpermitted_structures__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home? *</label>
                            {this.getInput('yesNo', 'Was_the_customer_home__c', this.state.Was_the_customer_home__c)}
                        </div>
                        <div className={this.state.Was_the_customer_home__c === 'Yes' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                            <label className="text-primary m-0 py-2">Please schedule a new appointment after saving the job.</label>
                        </div>
                        <div className={this.state.Was_the_customer_home__c === 'No' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What is needed from the RSS?</label>
                            {this.getInput('textarea', 'What_do_we_need_from_this_RSS__c', this.state.What_do_we_need_from_this_RSS__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Drone Survey *</label>
                            {this.getInput('yesNo', 'Drone_Survey__c', this.state.Drone_Survey__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Internet Access?</label>
                            {this.getInput('multiPicklist', 'Internet_Access__c', this.state.Internet_Access__c, this.pickfields.Internet_Access__c.picklistValues)}
                        </div>

                        {/* Conditional Render when Manufactured Home */}
                        <div className={this.props.session.Manufactured_home__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Manufactured home?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.session.Manufactured_home__c ? this.props.session.Manufactured_home__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Took pictures of HUD Label and Decal?</label>
                                {this.getInput('yesNo', 'Took_pictures_of_HUD_Label_and_Decal__c', this.state.Took_pictures_of_HUD_Label_and_Decal__c)}
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes House */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('House') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Roof</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure Levels *</label>
                                {this.getInput('num', 'Structure_Levels__c', this.state.Structure_Levels__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Ceiling Type</label>
                                {this.getInput('picklist', 'Ceiling_Type__c', this.state.Ceiling_Type__c, this.pickfields.Ceiling_Type__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Attic Structure</label>
                                {this.getInput('picklist', 'Attic_Structure__c', this.state.Attic_Structure__c, this.pickfields.Attic_Structure__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Plywood?</label>
                                {this.getInput('yesNo', 'Plywood__c', this.state.Plywood__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Solar *</label>
                                {this.getInput('yesNo', 'Is_There_Existing_Solar__c', this.state.Is_There_Existing_Solar__c)}
                            </div>

                            {/* Conditional Rendering for Existing Solar Roof Questions */}
                            <div className={this.state.Is_There_Existing_Solar__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Array Tilt</label>
                                    {this.getInput('num', 'Existing_Array_Tilt__c', this.state.Existing_Array_Tilt__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Array Azimuth</label>
                                    {this.getInput('num', 'Existing_Array_Azimuth__c', this.state.Existing_Array_Azimuth__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Module Make and Model Number</label>
                                    {this.getInput('text', 'Existing_module_number__c', this.state.Existing_module_number__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Number of Existing Modules</label>
                                    {this.getInput('num', 'Number_of_existing_modules__c', this.state.Number_of_existing_modules__c)}
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Rafters</label>
                                {this.getInput('text', 'Rafters2__c', this.state.Rafters2__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Rafter Spacing (approx inches)</label>
                                {this.getInput('num', 'Rafter_Spacing2__c', this.state.Rafter_Spacing2__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Tilt</label>
                                {this.getInput('num', 'Roof_Tilt__c', this.state.Roof_Tilt__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Type</label>
                                {this.getInput('picklist', 'Roof_Type__c', this.state.Roof_Type__c, this.pickfields.Roof_Type__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Tile Weight *</label>
                                <br></br>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Pounds</label>
                                {this.getInput('num', 'tilePounds', this.state.tilePounds)}
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Ounces</label>
                                {this.getInput('num', 'tileOunces', this.state.tileOunces)}
                                <br></br>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Fragile or lightweight tile?</label>
                                {this.getInput('yesNo', 'Fragile_or_lightweight_tile__c', this.state.Fragile_or_lightweight_tile__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">How many tiles did you break?</label>
                                {this.getInput('num', 'Number_of_Broken_Tiles__c', this.state.Number_of_Broken_Tiles__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Condition</label>
                                {this.getInput('picklist', 'Roof_Condition__c', this.state.Roof_Condition__c, this.pickfields.Roof_Condition__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof mossy or slippery?</label>
                                {this.getInput('picklist', 'Roof_mossy_or_slippery__c', this.state.Roof_mossy_or_slippery__c, this.pickfields.Roof_mossy_or_slippery__c.picklistValues)}
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes Additional Structure */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Additional Structure') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Ceiling Type</label>
                                {this.getInput('picklist', 'Structure_2_Ceiling_Type__c', this.state.Structure_2_Ceiling_Type__c, this.pickfields.Structure_2_Ceiling_Type__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Attic Structure</label>
                                {this.getInput('picklist', 'Structure_2_Attic_Structure__c', this.state.Structure_2_Attic_Structure__c, this.pickfields.Structure_2_Attic_Structure__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Rafters</label>
                                {this.getInput('text', 'Structure_2_Rafters__c', this.state.Structure_2_Rafters__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Rafter Spacing</label>
                                {this.getInput('num', 'Structure_2_Rafter_Spacing__c', this.state.Structure_2_Rafter_Spacing__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Tilt</label>
                                {this.getInput('num', 'Structure_2_Roof_Tilt__c', this.state.Structure_2_Roof_Tilt__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Type</label>
                                {this.getInput('picklist', 'Structure_2_Roof_Type__c', this.state.Structure_2_Roof_Type__c, this.pickfields.Structure_2_Roof_Type__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Fragile or Lightweight Tile</label>
                                {this.getInput('picklist', 'Structure_2_Fragile_or_Lightweight_Tile__c', this.state.Structure_2_Fragile_or_Lightweight_Tile__c, this.pickfields.Structure_2_Fragile_or_Lightweight_Tile__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 How many tiles did you break?</label>
                                {this.getInput('num', 'Structure_2_Number_of_Broken_Tiles__c', this.state.Structure_2_Number_of_Broken_Tiles__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Condition</label>
                                {this.getInput('picklist', 'Structure_2_Roof_Condition__c', this.state.Structure_2_Roof_Condition__c, this.pickfields.Structure_2_Roof_Condition__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Mossy or Slippery?</label>
                                {this.getInput('picklist', 'Structure_2_Roof_Mossy_or_Slippery__c', this.state.Structure_2_Roof_Mossy_or_Slippery__c, this.pickfields.Structure_2_Roof_Mossy_or_Slippery__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Third structure being surveyed?</label>
                                {this.getInput('yesNo', 'Third_structure_being_surveyed__c', this.state.Third_structure_being_surveyed__c)}
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled as GM or Both */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Ground Mount') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Ground Mount</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Waste Management Method</label>
                                {this.getInput('picklist', 'Waste_Management_Method__c', this.state.Waste_Management_Method__c, this.pickfields.Waste_Management_Method__c.picklistValues)}
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled: Electrical */}
                        <div className={this.props.session.Survey_Type__c !== null ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Electrical</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Siding Type (at MSP) *</label>
                                {this.getInput('picklist', 'Siding_Type__c', this.state.Siding_Type__c, this.pickfields.Siding_Type__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Service Meters *</label>
                                {this.getInput('yesNo', 'Multiple_Service_Meters__c', this.state.Multiple_Service_Meters__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Meter Number *</label>
                                {this.getInput('text', 'Meter_Number__c', this.state.Meter_Number__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Utility Feed *</label>
                                {this.getInput('picklist', 'Utility_Feed__c', this.state.Utility_Feed__c, this.pickfields.Utility_Feed__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Mounting *</label>
                                {this.getInput('picklist', 'MSP_Mounting__c', this.state.MSP_Mounting__c, this.pickfields.MSP_Mounting__c.picklistValues)}
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Grounding *</label>
                                {this.getInput('picklist', 'Grounding__c', this.state.Grounding__c, this.pickfields.Grounding__c.picklistValues)}
                            </div>
                            <div className={this.state.Grounding__c === '1 Ground Rod' || this.state.Grounding__c === 'Ground rod' || this.state.Grounding__c === 'Could not verify' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Ground Rod 811 Marking</label>
                                    {this.getInput('picklist', 'Ground_Rod_811_Marking__c', this.state.Ground_Rod_811_Marking__c, this.pickfields.Ground_Rod_811_Marking__c.picklistValues)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Ground Rod 811 Marking Notes</label>
                                    {this.getInput('textarea', 'Ground_Rod_811_Marking_Notes__c', this.state.Ground_Rod_811_Marking_Notes__c)}
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Gas Riser Distance (in) *</label>
                                {this.getInput('num', 'Gas_Riser_Distance_in__c', this.state.Gas_Riser_Distance_in__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Condition *</label>
                                {this.getInput('picklist', 'MSP_Condition__c', this.state.MSP_Condition__c, this.pickfields.MSP_Condition__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Brand *</label>
                                {this.getInput('picklist', 'MSP_Brand__c', this.state.MSP_Brand__c, this.pickfields.MSP_Brand__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Feed *</label>
                                {this.getInput('picklist', 'MSP_Feed__c', this.state.MSP_Feed__c, this.pickfields.MSP_Feed__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Special Panel?</label>
                                {this.getInput('picklist', 'Special_Panel__c', this.state.Special_Panel__c, this.pickfields.Special_Panel__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Main Breaker Rating *</label>
                                {this.getInput('picklist', 'Main_Breaker_Rating__c', this.state.Main_Breaker_Rating__c, this.pickfields.Main_Breaker_Rating__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Busbar Rating *</label>
                                {this.getInput('picklist', 'MSP_Busbar_Rating__c', this.state.MSP_Busbar_Rating__c, this.pickfields.MSP_Busbar_Rating__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Any panels missing dead front?</label>
                                {this.getInput('yesNo', 'Any_panels_missing_dead_front__c', this.state.Any_panels_missing_dead_front__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">TRX Shared?</label>
                                {this.getInput('picklist', 'TRX_Shared__c', this.state.TRX_Shared__c, this.pickfields.TRX_Shared__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Number of Sub Panels?</label>
                                {this.getInput('num', 'Number_of_Sub_panels__c', this.state.Number_of_Sub_panels__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">3 Phase?</label>
                                {this.getInput('yesNo', 'X3_Phase__c', this.state.X3_Phase__c)}
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Solar *</label>
                                {this.getInput('yesNo', 'Is_There_Existing_Solar__c', this.state.Is_There_Existing_Solar__c)}
                            </div>
                            {/* Conditional Rendering for Existing Solar Electrical Questions */}
                            <div className={this.state.Is_There_Existing_Solar__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing PV Breaker Size</label>
                                    {this.getInput('picklist', 'Existing_PV_Breaker_Size__c', this.state.Existing_PV_Breaker_Size__c, this.pickfields.Existing_PV_Breaker_Size__c.picklistValues)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Existing Inverters</label>
                                    {this.getInput('yesNo', 'Multiple_Existing_Inverters__c', this.state.Multiple_Existing_Inverters__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Inverter Make and Model Number</label>
                                    {this.getInput('text', 'Existing_Inverter_Model_Number__c', this.state.Existing_Inverter_Model_Number__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing ACD</label>
                                    {this.getInput('picklist', 'Existing_ACD__c', this.state.Existing_ACD__c, this.pickfields.Existing_ACD__c.picklistValues)}
                                </div>
                                {/* <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">System A Battery</label>
                                    {this.getInput('text', 'System_A_Battery__c', this.state.System_A_Battery__c)}
                                </div> */}
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">System A Battery</label>
                                    {this.getInput('picklist', 'System_A_Existing_Battery_Mfr__c', this.state.System_A_Existing_Battery_Mfr__c, this.pickfields.System_A_Existing_Battery_Mfr__c.picklistValues)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Existing Solar Systems</label>
                                    {this.getInput('yesNo', 'Multiple_Existing_Solar_Systems__c', this.state.Multiple_Existing_Solar_Systems__c)}
                                </div>
                                <div className={this.state.Multiple_Existing_Solar_Systems__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                    {/* <div>
                                        <label className="text-white col-sm-5 col-12 m-0 py-2">System B Battery</label>
                                        {this.getInput('text', 'System_B_Battery__c', this.state.System_B_Battery__c)}
                                    </div> */}
                                    <div>
                                        <label className="text-white col-sm-5 col-12 m-0 py-2">System B Battery</label>
                                        {this.getInput('picklist', 'System_B_Existing_Battery_Mfr__c', this.state.System_B_Existing_Battery_Mfr__c, this.pickfields.System_B_Existing_Battery_Mfr__c.picklistValues)}
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Trench Needed?</label>
                                {this.getInput('yesNo', 'Trench_Needed__c', this.state.Trench_Needed__c)}
                            </div>
                            <div className={this.state.Trench_Needed__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Trench Distance (approx feet)</label>
                                    {this.getInput('num', 'Trench_Distance__c', this.state.Trench_Distance__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Select Materials In The Trench Path</label>
                                    {this.getInput('picklist', 'Select_materials_in_the_trench_path__c', this.state.Select_materials_in_the_trench_path__c, this.pickfields.Select_materials_in_the_trench_path__c.picklistValues)}
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is there an existing EV charger?</label>
                                {this.getInput('yesNo', 'Is_there_an_existing_EV_charger__c', this.state.Is_there_an_existing_EV_charger__c)}
                            </div>
                            <div className={this.state.Is_there_an_existing_EV_charger__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">What is the Amperage of EV Charger Breaker?</label>
                                    {this.getInput('text', 'What_is_the_Amperage_of_EV_Charger_Break__c', this.state.What_is_the_Amperage_of_EV_Charger_Break__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Is the EV charger permitted?</label>
                                    {this.getInput('yesNo', 'Is_the_EV_charger_permitted__c', this.state.Is_the_EV_charger_permitted__c)}
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing generator or transfer switch?</label>
                                {this.getInput('picklist', 'Existing_generator_or_transfer_switch__c', this.state.Existing_generator_or_transfer_switch__c, this.pickfields.Existing_generator_or_transfer_switch__c.picklistValues)}
                            </div>
                            <div className={this.state.Existing_generator_or_transfer_switch__c === 'Generator' || this.state.Existing_generator_or_transfer_switch__c === 'Both' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">What is the Amperage of Generator Breaker?</label>
                                    {this.getInput('text', 'What_is_the_Amp_of_Generator_Breaker__c', this.state.What_is_the_Amp_of_Generator_Breaker__c)}
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Is the Generator permitted?</label>
                                    {this.getInput('yesNo', 'Is_the_Generator_permitted__c', this.state.Is_the_Generator_permitted__c)}
                                </div>
                            </div>

                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes Battery */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Battery') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Battery</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Largest Breaker</label>
                                {this.getInput('num', 'Largest_Breaker__c', this.state.Largest_Breaker__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">AC Unit</label>
                                {this.getInput('yesNo', 'AC_Unit__c', this.state.AC_Unit__c)}
                            </div>
                            <div className={this.state.AC_Unit__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Largest AC Unit Breaker Size</label>
                                    {this.getInput('num', 'Largest_AC_Unit_Breaker_Size__c', this.state.Largest_AC_Unit_Breaker_Size__c)}
                                </div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA1</label>
                                {this.getInput('num', 'LRA1__c', this.state.LRA1__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA2</label>
                                {this.getInput('num', 'LRA2__c', this.state.LRA2__c)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA3</label>
                                {this.getInput('num', 'LRA3__c', this.state.LRA3__c)}
                            </div>
                        </div>
                    </div> 
                    {/* End of Canelled Check */}

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Reschedule or Full Cancel? *</label>
                            {this.getInput('picklist', 'Cancellation_Type__c', this.state.Cancellation_Type__c, this.pickfields.Cancellation_Type__c.picklistValues)}
                        </div>
                        
                        <div className={this.state.Cancellation_Type__c === 'Reschedule' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home? *</label>
                                {this.getInput('yesNo', 'Was_the_customer_home__c', this.state.Was_the_customer_home__c)}
                            </div>
                            <div className={this.state.Was_the_customer_home__c === 'Yes' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                                <label className="text-primary m-0 py-2">Please schedule a new appointment after saving the job.</label>
                            </div>
                            <div className={this.state.Was_the_customer_home__c === 'No' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What is needed from the RSS?</label>
                                {this.getInput('textarea', 'What_do_we_need_from_this_RSS__c', this.state.What_do_we_need_from_this_RSS__c)}
                            </div>
                        </div>

                        <div className={this.state.Cancellation_Type__c === 'Full Cancel' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling? *</label>
                                {this.getInput('picklist', 'What_Was_The_Reason_For_Cancelling__c', this.state.What_Was_The_Reason_For_Cancelling__c, this.pickfields.What_Was_The_Reason_For_Cancelling__c.picklistValues)}
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed? *</label>
                                {this.getInput('yesNo', 'Needs_follow_up__c', this.state.Needs_follow_up__c)}
                            </div>
                        </div>
                    </div>

                    <h2 className="pt-4">Photos & Notes</h2>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Jobsite Photos</label>
                        {this.getInput('text', 'Dropbox_Link__c', this.state.Dropbox_Link__c)}
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Field Notes</label>
                        {this.getInput('textarea', 'Job_Notes__c', this.state.Job_Notes__c)}
                    </div>

                </div>

                :

                // Render when not editing
                <div className="text-white">
                    <h2 className="pt-4">General</h2>

                    <label className="col-sm-5 col-12 m-0 py-2">Site Survey Outcome</label>
                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Site_Survey_Outcome__c ? this.props.fieldJob.Site_Survey_Outcome__c : '---'}</div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? 'd-none' : ''}>
                        <div className={this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === null ? 'mt-0' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was Partially Completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_Partially_Completed__c ? this.props.fieldJob.What_Was_Partially_Completed__c : '---'}</div>
                        </div>
                        <div className={this.state.Site_Survey_Outcome__c === 'Full Completion' ? 'mt-0' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was Fully Completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_Fully_Completed__c ? this.props.fieldJob.What_Was_Fully_Completed__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Any unpermitted structures?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Any_unpermitted_structures__c ? this.props.fieldJob.Any_unpermitted_structures__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_customer_home__c ? this.props.fieldJob.Was_the_customer_home__c : '---'}</div>
                        </div>
                        <div className={this.state.Was_the_customer_home__c === 'Yes' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                            <label className="text-primary m-0 py-2">Please schedule a new appointment after saving the job.</label>
                        </div>
                        <div className={this.state.Was_the_customer_home__c === 'No' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What is needed from the RSS?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_do_we_need_from_this_RSS__c ? this.props.fieldJob.What_do_we_need_from_this_RSS__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Drone Survey</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Drone_Survey__c ? this.props.fieldJob.Drone_Survey__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Internet Access?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Internet_Access__c ? this.props.fieldJob.Internet_Access__c : '---'}</div>
                        </div>
                        
                        {/* Conditional Render when Manufactured Home */}
                        <div className={this.props.session.Manufactured_home__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Manufactured home?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.session.Manufactured_home__c ? this.props.session.Manufactured_home__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Took pictures of HUD Label and Decal?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Took_pictures_of_HUD_Label_and_Decal__c ? this.props.fieldJob.Took_pictures_of_HUD_Label_and_Decal__c : '---'}</div>
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes House */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('House') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Roof</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure Levels</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_Levels__c ? this.props.fieldJob.Structure_Levels__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Ceiling Type</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ceiling_Type__c ? this.props.fieldJob.Ceiling_Type__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Attic Structure</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Attic_Structure__c ? this.props.fieldJob.Attic_Structure__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Plywood?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Plywood__c ? this.props.fieldJob.Plywood__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Solar</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_There_Existing_Solar__c ? this.props.fieldJob.Is_There_Existing_Solar__c : '---'}</div>
                            </div>

                            {/* Conditional Rendering for Existing Solar Roof Questions */}
                            <div className={this.state.Is_There_Existing_Solar__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Array Tilt</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_Array_Tilt__c ? this.props.fieldJob.Existing_Array_Tilt__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Array Azimuth</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_Array_Azimuth__c ? this.props.fieldJob.Existing_Array_Azimuth__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Module Make and Model Number</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_module_number__c ? this.props.fieldJob.Existing_module_number__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Number of Existing Modules</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Number_of_existing_modules__c ? this.props.fieldJob.Number_of_existing_modules__c : '---'}</div>
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Rafters</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Rafters2__c ? this.props.fieldJob.Rafters2__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Rafter Spacing (approx inches)</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Rafter_Spacing2__c ? this.props.fieldJob.Rafter_Spacing2__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Tilt</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_Tilt__c ? this.props.fieldJob.Roof_Tilt__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Type</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_Type__c ? this.props.fieldJob.Roof_Type__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Tile Weight</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Tile_Weight__c ? this.props.fieldJob.Tile_Weight__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Fragile or lightweight tile?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Fragile_or_lightweight_tile__c ? this.props.fieldJob.Fragile_or_lightweight_tile__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">How many tiles did you break?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Number_of_Broken_Tiles__c ? this.props.fieldJob.Number_of_Broken_Tiles__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Condition</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_Condition__c ? this.props.fieldJob.Roof_Condition__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Roof mossy or slippery?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_mossy_or_slippery__c ? this.props.fieldJob.Roof_mossy_or_slippery__c : '---'}</div>
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes Additional Structure */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Additional Structure') ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Ceiling Type</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Ceiling_Type__c ? this.props.fieldJob.Structure_2_Ceiling_Type__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Attic Structure</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Attic_Structure__c ? this.props.fieldJob.Structure_2_Attic_Structure__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Rafters</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Rafters__c ? this.props.fieldJob.Structure_2_Rafters__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Rafter Spacing</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Rafter_Spacing__c ? this.props.fieldJob.Structure_2_Rafter_Spacing__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Tilt</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Roof_Tilt__c ? this.props.fieldJob.Structure_2_Roof_Tilt__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Type</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Roof_Type__c ? this.props.fieldJob.Structure_2_Roof_Type__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Fragile or Lightweight Tile</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Fragile_or_Lightweight_Tile__c ? this.props.fieldJob.Structure_2_Fragile_or_Lightweight_Tile__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 How many tiles did you break?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Number_of_Broken_Tiles__c ? this.props.fieldJob.Structure_2_Number_of_Broken_Tiles__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Condition</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Roof_Condition__c ? this.props.fieldJob.Structure_2_Roof_Condition__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Structure #2 Roof Mossy or Slippery?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Structure_2_Roof_Mossy_or_Slippery__c ? this.props.fieldJob.Structure_2_Roof_Mossy_or_Slippery__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Third structure being surveyed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Third_structure_being_surveyed__c ? this.props.fieldJob.Third_structure_being_surveyed__c : '---'}</div>
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled as GM or Both */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Ground Mount') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Ground Mount</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Waste Management Method</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Waste_Management_Method__c ? this.props.fieldJob.Waste_Management_Method__c : '---'}</div>
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled: Electrical */}
                        <div className={this.props.session.Survey_Type__c !== null ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Electrical</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Siding Type (at MSP)</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Siding_Type__c ? this.props.fieldJob.Siding_Type__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Service Meters</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Multiple_Service_Meters__c ? this.props.fieldJob.Multiple_Service_Meters__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Meter Number</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Meter_Number__c ? this.props.fieldJob.Meter_Number__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Utility Feed</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Utility_Feed__c ? this.props.fieldJob.Utility_Feed__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Mounting</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.MSP_Mounting__c ? this.props.fieldJob.MSP_Mounting__c : '---'}</div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Grounding</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Grounding__c ? this.props.fieldJob.Grounding__c : '---'}</div>
                            </div>
                            <div className={this.state.Grounding__c === '1 Ground Rod' || this.state.Grounding__c === 'Ground rod' || this.state.Grounding__c === 'Could not verify' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Ground Rod 811 Marking</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ground_Rod_811_Marking__c ? this.props.fieldJob.Ground_Rod_811_Marking__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Ground Rod 811 Marking Notes</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ground_Rod_811_Marking_Notes__c ? this.props.fieldJob.Ground_Rod_811_Marking_Notes__c : '---'}</div>
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Gas Riser Distance (in)</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Gas_Riser_Distance_in__c ? this.props.fieldJob.Gas_Riser_Distance_in__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Condition</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.MSP_Condition__c ? this.props.fieldJob.MSP_Condition__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Brand</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.MSP_Brand__c ? this.props.fieldJob.MSP_Brand__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Feed</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.MSP_Feed__c ? this.props.fieldJob.MSP_Feed__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Special Panel?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Special_Panel__c ? this.props.fieldJob.Special_Panel__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Main Breaker Rating</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Main_Breaker_Rating__c ? this.props.fieldJob.Main_Breaker_Rating__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">MSP Busbar Rating</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.MSP_Busbar_Rating__c ? this.props.fieldJob.MSP_Busbar_Rating__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Any panels missing dead front?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Any_panels_missing_dead_front__c ? this.props.fieldJob.Any_panels_missing_dead_front__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">TRX Shared?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.TRX_Shared__c ? this.props.fieldJob.TRX_Shared__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Number of Sub Panels?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Number_of_Sub_panels__c ? this.props.fieldJob.Number_of_Sub_panels__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">3 Phase?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.X3_Phase__c ? this.props.fieldJob.X3_Phase__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Solar</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_There_Existing_Solar__c ? this.props.fieldJob.Is_There_Existing_Solar__c : '---'}</div>
                            </div>
                            <div className={this.props.fieldJob.Is_There_Existing_Solar__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing PV Breaker Size</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_PV_Breaker_Size__c ? this.props.fieldJob.Existing_PV_Breaker_Size__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Existing Inverters</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Multiple_Existing_Inverters__c ? this.props.fieldJob.Multiple_Existing_Inverters__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing Inverter Make and Model Number</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_Inverter_Model_Number__c ? this.props.fieldJob.Existing_Inverter_Model_Number__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Existing ACD</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_ACD__c ? this.props.fieldJob.Existing_ACD__c : '---'}</div>
                                </div>
                                {/* <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">System A Battery</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.System_A_Battery__c ? this.props.fieldJob.System_A_Battery__c : '---'}</div>
                                </div> */}
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">System A Battery</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.System_A_Existing_Battery_Mfr__c ? this.props.fieldJob.System_A_Existing_Battery_Mfr__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Multiple Existing Solar Systems</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Multiple_Existing_Solar_Systems__c ? this.props.fieldJob.Multiple_Existing_Solar_Systems__c : '---'}</div>
                                </div>
                                <div className={this.state.Multiple_Existing_Solar_Systems__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                    {/* <div>
                                        <label className="text-white col-sm-5 col-12 m-0 py-2">System B Battery</label>
                                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.System_B_Battery__c ? this.props.fieldJob.System_B_Battery__c : '---'}</div>
                                    </div> */}
                                    <div>
                                        <label className="text-white col-sm-5 col-12 m-0 py-2">System B Battery</label>
                                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.System_B_Existing_Battery_Mfr__c ? this.props.fieldJob.System_B_Existing_Battery_Mfr__c : '---'}</div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Trench Needed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Trench_Needed__c ? this.props.fieldJob.Trench_Needed__c : '---'}</div>
                            </div>
                            <div className={this.props.fieldJob.Trench_Needed__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Trench Distance (approx feet)</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Trench_Distance__c ? this.props.fieldJob.Trench_Distance__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Select Materials In The Trench Path</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Select_materials_in_the_trench_path__c ? this.props.fieldJob.Select_materials_in_the_trench_path__c : '---'}</div>
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is there an existing EV charger?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_there_an_existing_EV_charger__c ? this.props.fieldJob.Is_there_an_existing_EV_charger__c : '---'}</div>
                            </div>
                            <div className={this.state.Is_there_an_existing_EV_charger__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">What is the Amperage of EV Charger Breaker?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_is_the_Amperage_of_EV_Charger_Break__c ? this.props.fieldJob.What_is_the_Amperage_of_EV_Charger_Break__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Is the EV charger permitted?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_the_EV_charger_permitted__c ? this.props.fieldJob.Is_the_EV_charger_permitted__c : '---'}</div>
                                </div>
                            </div>

                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Existing generator or transfer switch?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Existing_generator_or_transfer_switch__c ? this.props.fieldJob.Existing_generator_or_transfer_switch__c : '---'}</div>
                            </div>
                            <div className={this.state.Existing_generator_or_transfer_switch__c === 'Generator' || this.state.Existing_generator_or_transfer_switch__c === 'Both' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">What is the Amperage of Generator Breaker?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_is_the_Amp_of_Generator_Breaker__c ? this.props.fieldJob.What_is_the_Amp_of_Generator_Breaker__c : '---'}</div>
                                </div>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Is the Generator permitted?</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_the_Generator_permitted__c ? this.props.fieldJob.Is_the_Generator_permitted__c : '---'}</div>
                                </div>
                            </div>
                        </div>

                        {/* Conditional Render when Completion filled and Survey Type Includes Battery */}
                        <div className={this.props.session.Survey_Type__c !== null && this.props.session.Survey_Type__c.includes('Battery') ? 'mt-0' : 'd-none'}>
                            <h2 className="pt-4">Battery</h2>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Largest Breaker</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Largest_Breaker__c ? this.props.fieldJob.Largest_Breaker__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">AC Unit</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.AC_Unit__c ? this.props.fieldJob.AC_Unit__c : '---'}</div>
                            </div>
                            <div className={this.props.fieldJob.AC_Unit__c === 'Yes' ? 'mt-0' : 'd-none'}>
                                <div>
                                    <label className="text-white col-sm-5 col-12 m-0 py-2">Largest AC Unit Breaker Size</label>
                                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Largest_AC_Unit_Breaker_Size__c ? this.props.fieldJob.Largest_AC_Unit_Breaker_Size__c : '---'}</div>
                                </div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA1</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.LRA1__c ? this.props.fieldJob.LRA1__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA2</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.LRA2__c ? this.props.fieldJob.LRA2__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">LRA3</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.LRA3__c ? this.props.fieldJob.LRA3__c : '---'}</div>
                            </div>
                        </div>
                    </div>

                    <div className={this.state.Site_Survey_Outcome__c === 'Cancelled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Reschedule or Full Cancel? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Cancellation_Type__c ? this.props.fieldJob.Cancellation_Type__c : '---'}</div>
                        </div>

                        <div className={this.state.Cancellation_Type__c === 'Reschedule' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_customer_home__c ? this.props.fieldJob.Was_the_customer_home__c : '---'}</div>
                            </div>
                            <div className={this.state.Was_the_customer_home__c === 'Yes' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                                <label className="text-primary m-0 py-2">Please schedule a new appointment after saving the job.</label>
                            </div>
                            <div className={this.state.Was_the_customer_home__c === 'No' && (this.state.Site_Survey_Outcome__c === 'Partial Completion' || this.state.Site_Survey_Outcome__c === 'Cancelled') ? '' : 'd-none'}>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What is needed from the RSS?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_do_we_need_from_this_RSS__c ? this.props.fieldJob.What_do_we_need_from_this_RSS__c : '---'}</div>
                            </div>
                        </div>

                        <div className={this.state.Cancellation_Type__c === 'Full Cancel' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c ? this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c : '---'}</div>
                            </div>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needs_follow_up__c ? this.props.fieldJob.Needs_follow_up__c : '---'}</div>
                            </div>
                        </div>
                    </div>

                    <h2 className="pt-4">Photos & Notes</h2>
                    <div>
                        <label className="text-white col-sm-5 col-6 m-0 py-2">Jobsite Photos</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Dropbox_Link__c ? this.props.fieldJob.Dropbox_Link__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-6 m-0 py-2">Field Notes</label>
                        <div className={this.props.fieldJob.Job_Notes__c ? "col-12" : "d-inline col-sm-7 col-12"}>{this.props.fieldJob.Job_Notes__c ? this.props.fieldJob.Job_Notes__c : '---'}</div>
                    </div>

                </div>
            }

            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(SurveyForm);